<div class='action-url-chat-bubble-container'>
  <div class='content-block'>
    <!-- Header section -->
    <div class='header-section'>
      @if (text) {
        <p class='header'>{{ text }}</p>
      }
    </div>

    <!-- Body and footer text -->
    <div class='text-content'>
      @if (body) {
        <p class='body'>{{ body }}</p>
      }
      @if (footer) {
        <p class='footer'>{{ footer }}</p>
      }
    </div>

    <!-- Separator line -->
    <div class='separator'></div>

    <!-- CTA Button -->
    <button class="cta-button" (click)='openUrl()'>
      <svg class='external-link-icon' viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 2H14V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 2L8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 9V13C12 13.5523 11.5523 14 11 14H3C2.44772 14 2 13.5523 2 13V5C2 4.44772 2.44772 4 3 4H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ title }}
    </button>
  </div>
</div>